import React from 'react'
let rooturl     = 'https://primecapitalmarkets.net'
let url         = process.env.PUBLIC_URL
let admin       = process.env.PUBLIC_URL+'/admin'
let client      = process.env.PUBLIC_URL+'/client'
let company     = 'Gold Grup Limited'

let imagesurl   = 'https://primecapitalmarkets.net/assets/images'


export function CompanyName() {
	return company;
}
export function ImagesURL(props) {
	return imagesurl+props;
}
export function WindowLocationRootURL(props) {
	return window.location.href = rooturl+props;
}
export function RootURL(props) {
	return rooturl+props;
}
export function WindowReload(props){
   return window.location.reload();
}

// Application URL
export function WindowLocation(props) {
	return window.location.href = url+props;
}
export function WindowURL(props) {
	return url+props;
}



// Admin URL
export function WindowLocationAdmin(props) {
	return window.location.href = admin+props;
}
export function WindowURLAdmin(props) {
	return admin+props;
}

// Client URL
export function WindowLocationClient(props) {
	return window.location.href = client+props;
}
export function WindowURLClient(props) {
	return client+props;
}
